import LandingPage from './LandingPage';

function App() {
  return (
    <div className="bg-[#090E16] p-10">
      <LandingPage />
    </div>
  );
}

export default App;
